$(document).ready(function(){
    
    $('.ox_mn_btn').click(function(e){
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(".pp_outer").offset().top
        }, 500);
    });

    $('.pp_atc_btn').click(function(e){
        e.preventDefault();
        var currentId = $(this).attr('data-id');
        var currentQty = $(this).attr('data-qty');

        jQuery.ajax({
            type: "POST",
            url: "/cart/clear.js",
            dataType: "json",
            success: function() {
              var items = [];
              items.push({ id: currentId, quantity: currentQty });


              // Add the items to the cart
              $.ajax({
                  type: "POST",
                  url: "/cart/add.js", 
                  data: {
                      items: items,
                  },
                  dataType: "json",
                  success: function(data) {
                      window.location.href = '/checkout';
                  },
                  error: function() {
                      alert('Error adding the items to the cart.');
                  }
              });
            },
            error: function() {
                alert('Error clearing the cart.');
            }
          });
    });

});